import {
  RECEIVE_ACCOUNT,
  RECEIVE_CURRENT_ACCOUNT,
  RECEIVE_SELECTED_ACCOUNT,
  SWITCH_SELECTED_ACCOUNT,
} from '../action-types';

export const receiveAccount = (account) => ({
  type: RECEIVE_ACCOUNT,
  account,
});

export const receiveCurrentAccount = (currentAccount) => ({
  type: RECEIVE_CURRENT_ACCOUNT,
  currentAccount,
});

export const receiveSelectedAccount = (selectedAccount) => ({
  type: RECEIVE_SELECTED_ACCOUNT,
  selectedAccount,
});

export const switchSelectedAccount = (selectedAccount) => ({
  type: SWITCH_SELECTED_ACCOUNT,
  selectedAccount,
});
